module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 012.a578fc4a.jpg";